import React from "react";
import EditorialInline from "./EditorialInline";
import { usePublicLanguage } from "../context/PublicLanguage";
import { Lightbulb, AlertCircle, Eye } from "lucide-react";

export default function TheDish({ dish }) {
  const { t, language } = usePublicLanguage();
  if (!dish) return null;
  const rows = [
    { key: "what_happened", label: "What happened", icon: AlertCircle },
    { key: "why_it_matters", label: "Why it matters", icon: Lightbulb },
    { key: "what_to_watch", label: "What to watch", icon: Eye },
  ];
  return (
    <aside
      className="mt-0 mb-6 rounded-lg overflow-hidden"
      style={{ background: "#111315", borderLeft: "3px solid #FF8A1F", border: "1px solid rgba(255,138,31,0.22)" }}
      data-testid="the-dish-box"
    >
      <div className="px-6 pt-5 pb-3 flex items-center gap-2.5 border-b" style={{ borderColor: "rgba(255,255,255,0.07)" }}>
        <span className="font-display font-extrabold text-white tracking-tight text-lg">The Dish</span>
        <span lang={language} className="td-eyebrow" style={{ color: "#FF8A1F", fontSize: "0.56rem" }}>
          {t("Signature summary")}
        </span>
      </div>
      <div className="p-6 space-y-5">
        {dish.summary && <p className="text-[#E9E9E4] leading-relaxed"><EditorialInline text={dish.summary} /></p>}
        {dish.key_takeaways?.length > 0 && <ul className="list-disc pl-5 space-y-2 text-[#E9E9E4]">
          {dish.key_takeaways.map((item, index) => <li key={index}><EditorialInline text={item} /></li>)}
        </ul>}
        {rows.filter(({ key }) => dish[key]).map(({ key, label, icon: Icon }) => (
          <div key={key} className="flex gap-3.5">
            <div
              className="shrink-0 w-8 h-8 rounded-md flex items-center justify-center mt-0.5"
              style={{ background: "rgba(255,138,31,0.12)", color: "#FF8A1F" }}
            >
              <Icon size={16} />
            </div>
            <div>
              <div lang={language} className="td-eyebrow mb-1" style={{ color: "#FF8A1F", fontSize: "0.6rem" }}>
                {t(label)}
              </div>
              <p className="text-[#E9E9E4] leading-relaxed" style={{ fontSize: "1.02rem" }}>
                <EditorialInline text={dish[key]} />
              </p>
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}
